import { render, staticRenderFns } from "./resourceIntegration.vue?vue&type=template&id=6259f3f0&scoped=true"
import script from "./resourceIntegration.vue?vue&type=script&lang=js"
export * from "./resourceIntegration.vue?vue&type=script&lang=js"
import style0 from "./resourceIntegration.vue?vue&type=style&index=0&id=6259f3f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6259f3f0",
  null
  
)

export default component.exports